import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";

import Grid from "@mui/material/Grid";
import WWAdminBox from "../../Components/AdminComponents/WWAdminBox";
import WWAdminBox2 from "../../Components/AdminComponents/WWAdminBox2";
import WWAdminBoxMonthly from "../../Components/AdminComponents/WWAdminBoxMonthly";
import { getHodeStatistics, getStatisticsHours } from "./Services";
import { Typography } from "@mui/material";
// import { getRolesBySiteUuid } from "../../Layouts/Users/Services";

const StatisticsDashboard = (props) => {
  //Hooks
  const styles = useStyles();

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  //Status
  const [hodeStatistics, setHodeStatistics] = useState(null);
  const [trainerHours, setTrainerHours] = useState(0);
  const [learnerHours, setLearnerHours] = useState(0);

  const [trainerDuration, setTrainerDuration] = useState(30);
  const [learnerDuration, setLearnerDuration] = useState(30);
  const [evalDuration, setEvalDuration] = useState(30);

  const [resEvaluations, setResEvaluations] = useState({
    evalTotal: 0,
    evalPending: 0,
  });

  // React initial executed
  useEffect(() => {
    getStatistics();
  }, []);

  useEffect(() => {
    getTrainerHours();
  }, [trainerDuration]);

  useEffect(() => {
    getLearnerHours();
  }, [learnerDuration]);

  useEffect(() => {
    getEvaluationsData();
  }, [evalDuration]);

  const getStatistics = async () => {
    let statisticsData = await getHodeStatistics({
      site_uuid: userInfo.site_uuid,
    });
    // console.log("statisticsData====>", statisticsData);
    setHodeStatistics(statisticsData);
  };

  const getTrainerHours = async () => {
    let params = {
      site_uuid: userInfo.site_uuid,
      type: "trainerHoursStatistics",
      duration: trainerDuration,
    };
    let resTrainerHours = await getStatisticsHours(params);
    console.log("resTrainerHours", resTrainerHours);

    let milliseconds = resTrainerHours.data.trainerHours;
    let trainerHr = Math.ceil(milliseconds / 3600000);
    trainerHr = trainerHr < 10 ? "0" + trainerHr : trainerHr;
    setTrainerHours(trainerHr);
  };

  const getLearnerHours = async () => {
    let params = {
      site_uuid: userInfo.site_uuid,
      type: "learnerHoursStatistics",
      duration: learnerDuration,
    };
    let resLearnersHours = await getStatisticsHours(params);
    let milliseconds = resLearnersHours.data.learnerHours;
    let learnerHr = Math.ceil(milliseconds / 3600000);
    learnerHr = learnerHr < 10 ? "0" + learnerHr : learnerHr;
    setLearnerHours(learnerHr);
  };

  const getEvaluationsData = async () => {
    let params = {
      site_uuid: userInfo.site_uuid,
      type: "evaluationStatistics",
      duration: evalDuration,
    };
    let resEvaluations = await getStatisticsHours(params);
    let evalComplete =
      resEvaluations.data.evalComplete < 10
        ? "0" + resEvaluations.data.evalComplete
        : resEvaluations.data.evalComplete;
    let evalPending =
      resEvaluations.data.evalPending < 10
        ? "0" + resEvaluations.data.evalPending
        : resEvaluations.data.evalPending;
    let evalTotal = +evalComplete + +evalPending;
    evalTotal = evalTotal < 10 ? "0" + evalTotal : evalTotal;
    setResEvaluations((prev) => ({
      ...prev,
      evalTotal: evalTotal,
      evalPending: evalPending,
    }));
  };

  return (
    <Grid
      container
      className={styles.scrollBar}
      sx={{ flexDirection: "row", height: "62vh", overflow: "auto" }}
    >
      <Grid item xs={12}>
        <Grid container sx={{ flexDirection: "row", display: "flex" }}>
          {hodeStatistics && hodeStatistics.data && (
            <>
              {userInfo.rolesInfo.title.toLowerCase() == "admin" && (
                <Grid item xs={12}>
                  <WWAdminBoxMonthly />
                </Grid>
              )}
              <Grid item xs={6}>
                <WWAdminBox
                  totCount={hodeStatistics.data.totTrainers}
                  text={"Trainers"}
                />
              </Grid>
              <Grid item xs={6}>
                <WWAdminBox2
                  activeCount={trainerHours + " Trainer Hours"}
                  text={
                    trainerDuration == 0
                      ? ""
                      : `of last ${trainerDuration} days`
                  }
                  filterByDays={(params) => {
                    setTrainerDuration(params.value);
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <WWAdminBox
                  totCount={hodeStatistics.data.totLearners}
                  text={"Learners"}
                />
              </Grid>
              <Grid item xs={6}>
                <WWAdminBox2
                  activeCount={learnerHours + " Learner Hours"}
                  text={
                    learnerDuration == 0
                      ? ""
                      : `of last ${learnerDuration} days`
                  }
                  filterByDays={(params) => {
                    setLearnerDuration(params.value);
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <WWAdminBox
                  totCount={hodeStatistics.data.totActiveAssign + " of"}
                  text={`${hodeStatistics.data.totAssignments} Assignments Active`}
                />
              </Grid>
              <Grid item xs={6}>
                <WWAdminBox2
                  activeCount={resEvaluations.evalPending + " of"}
                  totCount={resEvaluations.evalTotal}
                  text={"Evaluations Pending"}
                  filterByDays={(params) => {
                    setEvalDuration(params.value);
                  }}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default StatisticsDashboard;
